
export const A11Y_ICON_LABEL_MAP = {
	star: 'Add favorite',
	trash: 'Remove favorite',
	'current-location': 'Default location'
};

export const TRACKING_MAP = {
	switch: makeTracking('switch-location'),
	star: makeTracking('add-location-favorite'),
	trash: makeTracking('remove-location-favorite')
};

function makeTracking(id) {
	return { 'data-tracking-id': id };
}



// WEBPACK FOOTER //
// ../node_modules/@cube/location-widget/src/components/icon-list-item/constants.js